import { ROUTES } from '@/shared/constants/routes';

export type ConsoleTab = 'sources' | 'access';

export const CONSOLE_TAB_PARAM = 'tab';

export function toConsoleTab(raw: string | null): ConsoleTab {
  return raw === 'access' ? 'access' : 'sources';
}

export function workspaceSourcesPath(
  projectId: string,
  params: Readonly<Record<string, string | readonly string[]>> = {},
): string {
  const path = ROUTES.DATA_CONSOLE_SOURCES.replace(':projectId', encodeURIComponent(projectId));
  const search = new URLSearchParams();
  for (const [name, value] of Object.entries(params)) {
    for (const item of typeof value === 'string' ? [value] : value) search.append(name, item);
  }
  const query = search.toString();

  return query ? `${path}?${query}` : path;
}

export function consolePath(tab: ConsoleTab): string {
  return `${ROUTES.DATA_CONSOLE}?${CONSOLE_TAB_PARAM}=${tab}`;
}
